module.exports = __webpack_public_path__ + "img/sankaku_blue.5996c7a9.png";